import * as React from 'react';
import { useTheme } from 'styled-components';

interface LogoIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  color?: 'dark' | 'disabled' | 'white' | 'red';
}

export const LogoIcon: React.FC<LogoIconProps> = ({
  className,
  color,
  ...props
}) => {
  const theme = useTheme();

  const getColor = (color: any) => {
    switch (color) {
      case 'dark':
        return theme.colors.accentHover;
      case 'disabled':
        return theme.colors.secondary;
      case 'white':
        return theme.colors.white;
      case 'red':
        return theme.colors.accent;
      default:
        return theme.colors.white;
    }
  };

  return (
    <svg
      width={28}
      height={25}
      viewBox="0 0 28 25"
      className={className || ''}
      {...props}
    >
      <path
        fill={getColor(color)}
        d="M22.5,11.5L11,0V11.5L0,0V19.5l5.47,5.5,.03-11.5,11.5,11.5V13.5l11,11.5V5.5L22.5,0V11.5Z"
      />
    </svg>
  );
};

export default LogoIcon;
